import { createReducer, on } from '@ngrx/store';
import * as FileExportActions from './file-export.actions';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { FileExportDomain } from '@mode/shared/contract-common';

export const fileExportFeatureKey = 'fileExport';

export const adapter = createEntityAdapter<FileExportDomain.FileExport>({
  selectId: (entity) => entity.id,
  sortComparer: (a, b) => (a.id === b.id ? 0 : a.id > b.id ? -1 : 1),
});

export const initialState: EntityState<FileExportDomain.FileExport> = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(FileExportActions.chartExportCsvFailed, FileExportActions.retryExportFailed, (state, action) =>
    adapter.updateOne(
      {
        changes: {
          error: action.error,
          status: FileExportDomain.ExportStatus.Error,
          completeDate: new Date(),
        },
        id: action.id,
      },
      state
    )
  ),
  // SCAL-317800: keep the row alive as Processing (client gave up, server likely still running) to re-attach.
  // Clear error/completeDate too: this transition is reachable from a prior Error (user clicked Retry on
  // a given-up export and it timed out again), so those terminal-state fields could otherwise go stale.
  on(FileExportActions.chartExportCsvStillProcessing, (state, action) =>
    adapter.updateOne(
      {
        id: action.id,
        changes: { status: FileExportDomain.ExportStatus.Processing, error: undefined, completeDate: undefined },
      },
      state
    )
  ),
  on(FileExportActions.chartExportCsvPlan, (state, action) =>
    adapter.upsertOne(
      {
        type: FileExportDomain.ExportType.Chart,
        id: action.plan.id,
        queryRunToken: action.queryRunToken,
        fileName: action.filename,
        status: FileExportDomain.ExportStatus.Init,
        createDate: new Date(),
        vizToken: action.token,
        plan: action.plan,
        refId: action.refId,
        budgetMs: action.budgetMs,
      },
      state
    )
  ),
  on(FileExportActions.chartExportCsvSuccess, FileExportActions.retryExportSuccess, (state, action) =>
    adapter.updateOne(
      {
        id: action.id,
        changes: {
          status: FileExportDomain.ExportStatus.Success,
          completeDate: new Date(),
          urlOrBlob: action.urlOrBlob,
        },
      },
      state
    )
  ),
  on(FileExportActions.deleteExport, (state, action) => adapter.removeOne(action.id, state)),
  on(FileExportActions.retryExport, (state, action) =>
    adapter.updateOne(
      {
        id: action.id,
        changes: {
          status: FileExportDomain.ExportStatus.Init,
          createDate: new Date(),
        },
      },
      state
    )
  ),
  on(FileExportActions.downloadExportSuccess, (state, action) => adapter.removeOne(action.id, state)),
  on(FileExportActions.downloadExportFailed, (state, action) =>
    adapter.updateOne(
      {
        id: action.id,
        changes: {
          error: action.error,
          status: FileExportDomain.ExportStatus.Error,
        },
      },
      state
    )
  )
);
